export default "__VITE_ASSET__DbsFQSzs__"